import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import { format } from 'date-fns'
import { bg } from 'date-fns/locale';
import jsonExcel from "../node_modules/vue-json-to-excel";
import Snotify from "vue-snotify";
import cloneDeep from 'lodash.clonedeep';
import VueI18n from "vue-i18n";
import vClickOutside from 'v-click-outside'
import './assets/styles/main.scss'

// import './registerServiceWorker.js'

Vue.config.productionTip = false;

Date.prototype.GetFirstDayOfWeek = function () {
  return new Date(
    this.setDate(this.getDate() - this.getDay() + (this.getDay() == 0 ? -6 : 1))
  );
};
Date.prototype.GetLastDayOfWeek = function () {
  return new Date(
    this.setDate(this.getDate() - (this.getDay() == 0 ? 7 : this.getDay()) + 7)
  );
};
Date.prototype.GetFirstDayOfMonth = function () {
  return new Date(this.getFullYear(), this.getMonth(), 1);
};
Date.prototype.GetLastDayOfMonth = function () {
  return new Date(this.getFullYear(), this.getMonth() + 1, 0);
};

Vue.prototype.$http = axios;
Vue.prototype.$cloneDeep = cloneDeep;
Vue.prototype.$eventBus = new Vue();

// Object.defineProperty(Vue.prototype, '$_', { value: _ });

const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

Vue.filter("formatDate", function (value) {
  if (value) {
    return format(new Date(value), 'dd/MM/yyyy')
  }
});
Vue.filter("formatDateDots", function (value) {
  if (value) {
    return format(new Date(value), 'dd.MM.yyyy')
  }
});

Vue.filter("formatFullDate", function (value) {
  if (value) {
    return format(new Date(value), 'dd/MM/yyyy - HH:mm:ss')
  }
});

Vue.filter("formatDay", function (value) {
  if (value) {
    return format(new Date(value), 'd MMMM', { locale: bg });
  }
});

Vue.filter("formatDayOfWeek", function (value) {
  if (value) {
    return format(new Date(value), 'EEEE', { locale: bg });
  }
});

Vue.filter("formatDayYear", function (value) {
  if (value) {
    return format(new Date(value), 'd MMMM yyyy', { locale: bg });
  }
});

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("getMonth", function (value) {
  if (value) {
    let month = format(new Date(value), 'MMMM', { locale: bg });
    return month[0].toUpperCase() + month.slice(1);
  }
});

const options = {
  toast: {
    timeout: 5000,
    showProgressBar: false,
  },
};
Vue.use(vClickOutside)

Vue.use(Snotify, options);

Vue.use(VueI18n);

const messages = {
  bg: require("./locale/bg.json"),
  en: require("./locale/en.json"),
};

const i18n = new VueI18n({
  locale: "bg",
  messages,
});

// VUE COMPONENTS
Vue.component("downloadExcel", jsonExcel);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
